<template>
    <div>
        <div style="display:flex; align-items: baseline;margin-bottom: 20px">
            <h2>付费记录</h2>
            <span style="margin-left: 20px;">用户id：{{ userData.userId }}</span>
        </div>

        <div style="padding: 0 20px;">
            <div style="display:flex; align-items: baseline;margin-bottom: 20px;">
                <span><h3>充值金币余额：{{ wallet.payBalance }}</h3></span>
                <span style="margin-left: 20px;"><h3>赠送金币余额：{{ wallet.bonusBalance }}</h3></span>
                <span style="margin-left: 20px;"><h3>累计过期金币：{{ wallet.cumulativeExpireBalance }}</h3></span>
            </div>
            <Table :columns="columns1" :data="tableData1">
            <template #main="{row}">
              <div>
                <span v-if="row.bonusChangeNum">{{ row.changeDirect===0?'+':'-' }} {{ row.bonusChangeNum||0 }}赠送金币</span>
                <span v-if="row.bonusChangeNum&&row.payChangeNum">，</span>
                <span v-if="row.payChangeNum">{{ row.changeDirect===0?'+':'-' }}{{ row.payChangeNum||0 }}充值金币</span>
              </div>
            </template>
            <Pages slot="footer" :page="page" :func="findData"></Pages>

            </Table>
        </div>

    </div>
</template>

<script>
import Pages from '@/components/pages'
import { getUserPayCoinsList } from '@/api/user'
export default {
  components: {
    Pages
  },
  props:{
    userData: {
      type: Object,
      default: () => ({})
    },
    wallet: {}
  },
  data() {
    return {
      page:{
        current: 1,
        size: 10,
        total: 0
      },
      tableData1:[],
      columns1: [
        {
          title:'明细id',
          key:'id'
        },
        {
          key:'changeDirectName',
          title:'变更方式'
        },
        {
          key:'changeChannelName',
          title:'变更渠道'
        },
        {
          key:'totalChangeNum',
          title:'变更数量'
        },
        {
          title:'变更详情',
          slot: 'main'
        },
        {
          key:'createTimeFmt',
          title:'发生时间'
        },
        {
          key:'playName',
          title:'描述'
        },
        {
          key:'changeExpireFmt',
          title:'有效期'
        }
      ]
    }
  },
  methods: {
    findData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getUserPayCoinsList({
        ...this.page,
        userId: this.userData.id
      }).then(r => {
        this.tableData1 = r.data.records
        this.page.total = r.data.total
      })
    }
  },
  mounted() {
    this.findData()
  }
}
</script>
